import { render, staticRenderFns } from "./AnswerSheet.vue?vue&type=template&id=08f6f77d&scoped=true"
import script from "./AnswerSheet.vue?vue&type=script&lang=js"
export * from "./AnswerSheet.vue?vue&type=script&lang=js"
import style0 from "./AnswerSheet.vue?vue&type=style&index=0&id=08f6f77d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f6f77d",
  null
  
)

export default component.exports